<template>
  <div class="add-new small-width">
    <div class="confirmation-bar">
      <Btn
        class="green d-inline-block m-r-20"
        :icon="{
          name: 'add',
          size: '18',
          color: '#fff',
        }"
        btnText="Submit"
        @btnClick="submit"/>
      <Btn
        class="gray d-inline-block"
        :icon="{
          name: 'check',
          size: '22',
          color: '#fff',
        }"
        btnText="Cancel"
        @btnClick="cancel"/>
    </div>
    <div class="card p-40">
      <div class="row">
        <InputText
          class="d-block col-xs-12"
          placeholder="Company Name"
          label="Company name"
          v-model="main.company_name"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="Name"
          label="Name"
          v-model="main.name"
          :rules="{required: true}"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="Address 1"
          label="Address"
          v-model="main.address_1"
          :rules="{required: true}"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="Address 2"
          label="Address"
          v-model="main.address_2"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-4"
          placeholder="Post Code"
          label="Post Code"
          v-model="main.post_code"
          :rules="{required: true}"
        />
        <InputText
          class="col-xs-4"
          placeholder="City"
          label="City"
          v-model="main.city"
          :rules="{required: true}"
        />
        <InputText
          class="col-xs-4"
          placeholder="State"
          label="State"
          v-model="main.state"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="Phone"
          label="Phone"
          v-model="main.phone"
          :rules="{required: true}"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="Email"
          label="email"
          v-model="main.email"
          :rules="{required: true, email: true}"
        />
      </div>
      <div class="row">
        <InputText
          class="col-xs-12"
          placeholder="External customer no"
          label="External customer no"
          v-model="main.external_customer_no"
          :rules="{required: false}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';

export default {
  name: 'AddNew',
  components: { Btn, InputText },
  data() {
    return {
      main: {
        company_name: '',
        name: '',
        address_1: 'Some Address 1',
        address_2: 'Some Address 2',
        city: 'Belgrade',
        post_code: 11000,
        country_id: 123,
        state: 'Serbia',
        phone: 1234123,
        email: 'some@mail.com',
        type: 1,
        external_customer_no: ''
      },
      alternative: {
        company_name: '',
        name: '',
        address_1: '',
        address_2: '',
        city: '',
        post_code: '',
        country_id: '',
        state: '',
        phone: '',
        email: '',
        external_customer_no: ''
      },
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('ADD_CUSTOMER', {
        ...this.main,
        alternativeAddress: { ...this.alternative },
      }).then(() => {
        this.$router.push('/customers');
      }).catch(() => {
        // console.log('its error');
      });
    },
    cancel() {
      this.$router.push('/customers');
    },
  },
  beforeDestroy() {
    window.scrollTo(0, 0);
  },
};
</script>
